module.exports = __webpack_public_path__ + "img/photo-6.7b60645f.jpg";